import React from 'react';

const ExitConfirmationModal = ({ isOpen, onContinue, onExit }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onContinue}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 p-6">
        {/* Close button */}
        <button
          onClick={onContinue}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>

        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img
            src="/mockup_images/marketing-remodel/AI-logoSmallWhite.png"
            alt="AI Logo"
            className="h-12 w-auto bg-[#4D95D8] p-2 rounded-lg"
          />
        </div>

        {/* Title */}
        <h2 className="text-xl font-bold text-gray-800 text-center mb-4">
          No / SCAM \ Alert.
        </h2>

        {/* Message */}
        <p className="text-gray-600 text-center mb-6">
          Your assessment is in progress. If you exit the current this assessment your responses will not be saved, and you'll have to restart the assessment..
        </p>

        {/* Buttons */}
        <div className="flex gap-4">
          <button
            onClick={onExit}
            className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors"
          >
            Exit Assessment
          </button>
          <button
            onClick={onContinue}
            className="flex-1 px-4 py-3 bg-[#4D95D8] text-white rounded-lg font-medium hover:opacity-90 transition-opacity"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExitConfirmationModal;
